import React from 'react';
import Framework from '@greenville/framework';
import env from '../../common/env';
import AgenticContainer from './AgenticContainer';
import AiAdminRedirect from '../../common/components/Redirect/AiAdminRedirect';

// Services
import TenantsService from './service/tenants/TenantsService';
import TenantProvidersService from './service/tenants/TenantProvidersService';
// Spec Model
import TenantsModel from './models/TenantsModel';

Framework.getClientManager().add({
  name: 'berlin',
  timeout: env.EVERGREEN_API_TIMEOUT,
  baseUrl: env.BERLIN_API_URI
});

export default {
  path: ['/', '/agentic', '/agentic/:tenantName/quizaet', '/agentic/*'],
  exact: false,
  services: [
    new TenantsService(),
    new TenantProvidersService()
    // new SysToSysTokenService()
  ],
  stores: [
    {
      name: 'tenantState',
      spec: TenantsModel,
      saveLocally: false,
      initialState: {
        tenantList: [],
        providerList: [],
        selectedTenant: {}
      }
    }
    // ,
    // {
    //   name: 'tokenState',
    //   spec: Tokens,
    //   saveLocally: false,
    //   initialState: {
    //     sysToSysToken: {},
    //   }
    // }
  ],

  render: (props) => {
    const { pathname } = window.location;

    // Handle /agentic/* paths - redirect to /berlin/aistudytool/studio
    if (pathname.startsWith('/agentic')) {
      const tenantName = pathname.split('/')[2] || 'aistudytools';
      return <AiAdminRedirect redirectPath={`/berlin/${tenantName}/studio`} />;
    }

    return <AgenticContainer {...props} />;
  }
};
